/* =====================================================================
   Au Delà des Fleurs — page panier « Le Sourire » (sections/adf-cart.liquid)
   1. Dit à cart.js (quantités, suppression) quelles zones de la page re-rendre.
   2. Mot sur la carte : modifiable dans le panier (/cart/change.js, propriétés gardées).
   3. « À ajouter au bouquet » : ajout en un clic (/cart/add.js) puis mise à jour de la page.
   Le choix livraison / retrait (Zapiet) est hors des zones re-rendues : il n'est jamais effacé.
   v14-7 : si le panier passe de « à livrer » à « rien à livrer » (ou l'inverse), on recharge la page.
   ===================================================================== */
(function () {
  'use strict';
  var root = function () { return document.querySelector('[data-adf-cartp]'); };
  if (!root()) return;
  var sectionId = function () { return root().getAttribute('data-section'); };
  var live = function (msg) { var r = document.getElementById('cart-live-region-text'); if (r) { r.textContent = msg; r.setAttribute('aria-hidden', 'false'); } };

  /* ---------- 1. cart.js : zones à re-rendre sur cette page ---------- */
  customElements.whenDefined('cart-items').then(function () {
    var C = customElements.get('cart-items');
    if (!C || C.prototype.__adf) return;
    C.prototype.__adf = true;
    var origSections = C.prototype.getSectionsToRender;
    C.prototype.getSectionsToRender = function () {
      if (!this.hasAttribute('data-adf-cart')) return origSections.call(this);
      var s = this.getAttribute('data-section');
      return [
        { id: 'main-cart-items', section: s, selector: '.js-adf-lines' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
        { id: 'main-cart-footer', section: s, selector: '.js-adf-totals' }
      ];
    };
    var origUpdate = C.prototype.onCartUpdate;
    C.prototype.onCartUpdate = function () {
      if (!this.hasAttribute('data-adf-cart')) return origUpdate.call(this);
      refresh();
    };
  });

  // v14-7 : le panier passe de « à livrer » à « rien à livrer » (entretien de tombe seul) ou l'inverse →
  // la zone livraison / retrait (Zapiet) et le bouton ne sont pas re-rendus : on recharge la page.
  var shipFlag = function () { var f = document.querySelector('[data-adf-ship]'); return f ? f.getAttribute('data-adf-ship') : null; };
  var ship0 = shipFlag();
  function checkShip() {
    var now = shipFlag();
    if (ship0 !== null && now !== null && now !== ship0 && document.querySelector('.adf-cartp .cart-item')) window.location.reload();
  }

  // v14-7 : rien à livrer → « Commander » ouvre la caisse par script (même code que dans le panier tiroir)
  if (!window.__adfGoCheckout) {
    window.__adfGoCheckout = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-adf-go-checkout]');
      if (!b) return;
      e.preventDefault();
      b.setAttribute('aria-busy', 'true');
      window.location.href = ((window.routes && window.routes.root_url) || '/').replace(/\/?$/, '/') + 'checkout';
    });
  }

  // Après chaque changement fait par cart.js : petits cadeaux, état vide, prix du bouton
  function afterRender(html) {
    checkShip();
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var a = document.querySelector('.js-adf-addons'), b = doc.querySelector('.js-adf-addons');
      if (a && b) a.innerHTML = b.innerHTML;
    }
    var empty = !document.querySelector('.adf-cartp .cart-item');
    root().classList.toggle('is-empty', empty);
    var price = document.querySelector('[data-adf-total]'), slot = document.querySelector('[data-adf-checkout-price]');
    if (price && slot) slot.textContent = price.textContent;
    var btn = document.getElementById('checkout'); if (btn && empty) btn.disabled = true;
  }
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (!e || e.source !== 'cart-items') return;
      afterRender(e.cartData && e.cartData.sections ? e.cartData.sections[sectionId()] : null);
    });
  });

  // Re-rend toute la page panier (après le mot sur la carte ou un petit cadeau)
  function refresh() {
    var s = sectionId();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(s) + ',cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data[s]) { window.location.reload(); return; }
        var doc = new DOMParser().parseFromString(data[s], 'text/html');
        ['.js-adf-lines', '.js-adf-totals', '.js-adf-addons'].forEach(function (sel) {
          var a = document.querySelector(sel), b = doc.querySelector(sel);
          if (a && b) a.innerHTML = b.innerHTML;
        });
        var empty = !doc.querySelector('.cart-item');
        var items = document.querySelector('cart-items[data-adf-cart]'); if (items) items.classList.toggle('is-empty', empty);
        var foot = document.getElementById('main-cart-footer'); if (foot) foot.classList.toggle('is-empty', empty);
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data['cart-icon-bubble']) {
          var bd = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (bd) bubble.innerHTML = bd.innerHTML;
        }
        afterRender(null);
      })
      .catch(function () { window.location.reload(); });
  }

  var post = function (url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  };
  var routes = window.routes || {};

  /* ---------- 2. Mot sur la carte ---------- */
  function toggleCard(card, open) {
    var form = card.querySelector('[data-adf-card-form]'), btn = card.querySelector('[data-adf-card-edit]');
    form.hidden = !open; card.classList.toggle('is-editing', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var ta = form.querySelector('textarea'); ta.focus(); ta.setSelectionRange(ta.value.length, ta.value.length); }
    else if (btn) btn.focus();
  }
  function saveCard(card) {
    var form = card.querySelector('[data-adf-card-form]');
    var ta = form.querySelector('textarea'), err = form.querySelector('[data-adf-card-error]'), save = form.querySelector('[data-adf-card-save]');
    var text = ta.value.trim();
    if (!text) { err.textContent = 'Écrivez votre mot, ou « non » si vous ne souhaitez pas de carte.'; err.hidden = false; ta.focus(); return; }
    var props = {};
    try { props = JSON.parse(form.getAttribute('data-props') || '{}') || {}; } catch (e) { props = {}; }
    /* Shopify rend item.properties en tableau de paires [[clé, valeur], …] : on le remet en objet,
       sinon /cart/change.js refuse (« expected Array to be a Hash ») et le mot n'est jamais enregistré. */
    if (Array.isArray(props)) {
      var o = {};
      props.forEach(function (pair) { if (Array.isArray(pair) && pair.length >= 2) o[pair[0]] = pair[1]; else if (pair && typeof pair === 'object' && 'first' in pair) o[pair.first] = pair.last; });
      props = o;
    }
    props[form.getAttribute('data-key')] = text;
    err.hidden = true; save.disabled = true; card.classList.add('is-saving');
    post((routes.cart_change_url || '/cart/change') + '.js', { line: parseInt(form.getAttribute('data-line'), 10), quantity: parseInt(form.getAttribute('data-qty'), 10), properties: props })
      .then(function () { live('Mot sur la carte enregistré'); return refresh(); })
      .catch(function () { err.textContent = 'Oups, le mot n\'a pas pu être enregistré. Réessayez, ou appelez-nous.'; err.hidden = false; save.disabled = false; card.classList.remove('is-saving'); });
  }

  /* ---------- 3. Petits cadeaux en un clic ---------- */
  function addAddon(btn) {
    var id = parseInt(btn.getAttribute('data-adf-addon'), 10);
    btn.disabled = true; btn.classList.add('is-loading');
    post((routes.cart_add_url || '/cart/add') + '.js', { items: [{ id: id, quantity: 1 }] })
      .then(function () { live('Ajouté au panier'); return refresh(); })
      .then(function () { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'adf-cart' }); })
      .catch(function (e) { btn.disabled = false; btn.classList.remove('is-loading'); var r = document.getElementById('cart-errors'); if (r) r.textContent = (window.adfApiError ? window.adfApiError(e) : '') || 'Impossible d\'ajouter ce produit pour le moment. Réessayez, ou appelez-nous.'; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var edit = t.closest('[data-adf-card-edit]');
    if (edit) { e.preventDefault(); var c = edit.closest('[data-adf-card]'); toggleCard(c, !c.classList.contains('is-editing')); return; }
    var cancel = t.closest('[data-adf-card-cancel]');
    if (cancel) { e.preventDefault(); toggleCard(cancel.closest('[data-adf-card]'), false); return; }
    var save = t.closest('[data-adf-card-save]');
    if (save) { e.preventDefault(); saveCard(save.closest('[data-adf-card]')); return; }
    var add = t.closest('[data-adf-addon]');
    if (add) { e.preventDefault(); addAddon(add); }
  });
  // Le champ du mot ne doit pas déclencher la mise à jour des quantités de cart.js (écouteur « change » sur <cart-items>)
  var form = document.getElementById('cart');
  if (form) {
    form.addEventListener('change', function (e) { if (e.target.closest('[data-adf-card-form]')) e.stopPropagation(); });
    form.addEventListener('keydown', function (e) {
      var ta = e.target.closest('[data-adf-card-input]'); if (!ta) return;
      if (e.key === 'Escape') { e.preventDefault(); toggleCard(ta.closest('[data-adf-card]'), false); }
      if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); saveCard(ta.closest('[data-adf-card]')); }
    });
  }
})();
